var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyNoCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8895 40.1465L11.4247 34.2201L4.54092 32.8068L5.31592 26.1054L0.939453 20.9995L5.31592 15.9392L4.54092 9.23771L11.4247 7.82448L14.8895 1.85242L20.9983 4.67889L27.1071 1.85242L30.6174 7.82448L37.4556 9.23771L36.6806 15.9392L41.0571 20.9995L36.6806 26.1054L37.4556 32.8068L30.6174 34.2201L27.1071 40.1465L20.9983 37.3201L14.8895 40.1465ZM16.1203 36.5451L20.9983 34.4936L26.013 36.5451L29.0674 31.9862L34.4012 30.6186L33.8542 25.1936L37.5468 20.9995L33.8542 16.7142L34.4012 11.2892L29.0674 10.0127L25.9218 5.45389L20.9983 7.50536L15.9836 5.45389L12.9292 10.0127L7.59534 11.2892L8.14239 16.7142L4.44975 20.9995L8.14239 25.1936L7.59534 30.7098L12.9292 31.9862L16.1203 36.5451Z",
    fill: "#898E9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyNoCheck);
export default __webpack_public_path__ + "static/media/grey-no-check.8b12a9794c3180c030bb47fa2e35b653.svg";
export { ForwardRef as ReactComponent };